import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { getCurrentUser, signOut, fetchUserAttributes } from 'aws-amplify/auth';
import '@aws-amplify/ui-react/styles.css';
import NavigationBar from './components/NavigationBar';
import Footer from './components/Footer'; 
import Login from './components/Login';
import LandingPage from './components/LandingPage';
import HomePage from './components/Homepage';
import UserProfile from './components/AccountDetails';
import CvAssistance from './components/CvAssistance';
import ListingsPage from './components/ListingsPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

import awsConfig from './aws-exports';

Amplify.configure(awsConfig);

function App() {
  const [showAuth, setShowAuth] = useState(false);
  const [authMode, setAuthMode] = useState('signin'); // 'signin' or 'signup'
  const [user, setUser] = useState(null);
  const [userAttributes, setUserAttributes] = useState(null);

  React.useEffect(() => {
    checkUser();
  }, []);

  React.useEffect(() => {
    if (user) {
      getUserAttributes();
    }
  }, [user]);
  
  async function getUserAttributes() {
    try {
      const attributes = await fetchUserAttributes();
      setUserAttributes(attributes);
    } catch (error) {
      console.log('Error fetching user attributes:', error);
    }
  }

  async function checkUser() {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
    } catch (err) {
      setUser(null);
    }
  }

  async function handleSignOut(isSignUp = false) {
    try {
      if (user) {
        await signOut();
        setUser(null);
      } else {
        // Toggle auth UI
        setShowAuth(true);
        // Set the auth mode based on which button was clicked
        setAuthMode(isSignUp ? 'signup' : 'signin');
      }
    } catch (error) {
      console.log('error signing out:', error);
    }
  }

  const toggleAuth = (isSignUp = false) => {
    setAuthMode(isSignUp ? 'signup' : 'signin');
    setShowAuth(true);
  };

  // Protected Route wrapper
  const ProtectedRoute = ({ children }) => {
    if (!user) {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  return (
    <Router>
      <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        {showAuth ? (
          <Login setUser={setUser} setShowAuth={setShowAuth} initialAuthMode={authMode} />
        ) : (
          <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <NavigationBar 
              signOut={user ? handleSignOut : toggleAuth} 
              username={userAttributes?.given_name || user?.username}
              isAuthenticated={!!user}
            />
            <div className="max-w-7xl mx-auto px-4 py-6" style={{ flex: 1 }}>
              <Routes>
                <Route 
                  path="/" 
                  element={!user ? <LandingPage toggleAuth={toggleAuth} /> : <HomePage userAttributes={userAttributes} />} 
                />
                <Route 
                  path="/AccountDetails" 
                  element={
                    <ProtectedRoute>
                      <UserProfile setUser={setUser} />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/CvAssistance" 
                  element={
                    <ProtectedRoute>
                      <CvAssistance />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/Listings" 
                  element={
                    <ProtectedRoute>
                      <ListingsPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/privacy" 
                  element={<PrivacyPolicy signOut={handleSignOut} isAuthenticated={!!user} />} 
                />
                <Route 
                  path="/terms" 
                  element={<TermsOfService signOut={handleSignOut} isAuthenticated={!!user} />} 
                />
              </Routes>
            </div>
            <Footer />
          </main>
        )}
      </div>
    </Router>
  );
}

export default App;